import utils from 'utils'

class redInkConfirmFormDownloadCtrl {
    constructor($scope, httpRequest, globalFn, logger, sweetalert, $filter, $uibModalInstance, $stateParams) {
        $scope.ukeyList = JSON.parse(localStorage.getItem('user_info')).tax4UkeyList
        $scope.dictData = {}
        $scope.dictData.cust_identity = [
            {
                enumCode: '0',
                enumName: '我是销售方',
            },
            {
                enumCode: '1',
                enumName: '我是购买方',
            },
        ]
        $scope.dictData.red_confirm_open_status = [
            {
                enumCode: '0',
                enumName: '未开具',
            },
            {
                enumCode: '1',
                enumName: '已开具',
            },
        ]
        $scope.dictData.red_confirm_status = [
            {enumName:"无需确认",enumCode:"01"},
            {enumName:"销方录入待购方确认",enumCode:"02"},
            {enumName:"购方录入待销方确认",enumCode:"03"},
            {enumName:"购销双方已确认",enumCode:"04"},
            {enumName:"作废（销方录入购方否认）",enumCode:"05"},
            {enumName:"作废（购方录入销方否认）",enumCode:"06"},
            {enumName:"作废（超72小时未确认）",enumCode:"07"},
            {enumName:"作废（发起方已撤销）",enumCode:"08"},
            {enumName:"作废（确认后撤销）",enumCode:"09"},
        ]
        $scope.dictData.red_confirm_status1 = [
            {enumName:"无需确认",enumCode:"01"},
            {enumName:"销方录入待购方确认",enumCode:"02"},
            {enumName:"购方录入待销方确认",enumCode:"03"},
            {enumName:"购销双方已确认",enumCode:"04"},
            {enumName:"作废（销方录入购方否认）",enumCode:"05"},
            {enumName:"作废（购方录入销方否认）",enumCode:"06"},
            {enumName:"作废（超72小时未确认）",enumCode:"07"},
            {enumName:"作废（发起方已撤销）",enumCode:"08"},
            {enumName:"作废（确认后撤销）",enumCode:"09"},
            {enumName:"作废(异常凭证）",enumCode:"10"},
        ]
        const types = ['identity','red_confirm_red_reason']
        httpRequest.get_dictByTypeArr(types).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        const nowDate = new Date()
        const aMonth = {
            start: $filter('date')(nowDate, 'yyyy-MM-01'),
            end:$filter('date')(nowDate, 'yyyy-MM-dd'),
        }
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                custIdentity:'0',
                createIdentity:'1',
                confirmStatus:'03',
                invoiceDateStart: aMonth.start,
                invoiceDateEnd: aMonth.end,
                ukeyId : $scope.ukeyList[0].ukeyId
            },
        }
        $scope.reset = function () {
            $scope.param.param = {
                custIdentity:'0',
                createIdentity:'1',
                confirmStatus:'03',
                invoiceDateStart: aMonth.start,
                invoiceDateEnd: aMonth.end,
                ukeyId : $scope.ukeyList[0].ukeyId
            }
        }
        $scope.reset()
        // 选中的发票
        $scope.selectedInvoices = []
        // 分页
        $scope.totalItems = 0 // 组件初始化设置总页数
        function queryList() {
            if(!$scope.param.param.invoiceDateStart && $scope.manageType!='7'){
                logger.logError('开票日期不能为空')
                return
            }
            const days = utils.DateMinus($scope.param.param.invoiceDateStart, $scope.param.param.invoiceDateEnd)
            if (days > 31 && $scope.manageType!='7') {
                logger.logError('开票日期查询跨度不允许超过一个月')
                return
            }
            let isSuccess = false
            httpRequest.post_downloadRedConfirmByPage($scope.param).then((res) => {
                $scope.invoiceList = res.data.value.list
                $scope.totalItems = res.data.value.total
                $scope.param.pageNum = res.data.value.pageNum
                $scope.selectedInvoices = []
                isSuccess = true
            }).finally(() => {
                // isShow(isSuccess)
            })
        }
        setTimeout(function () {
            $scope.ukeyChange()
            queryList()
        }, 100);
        $scope.pageChanged = function () {
            queryList()
        }
        $scope.search = function () {
            queryList()
        }
        $scope.$watch('param.param.custIdentity', () => {
            if($scope.param.param.custIdentity=='0'){
                $scope.param.param.confirmStatus='03'
            }
            if($scope.param.param.custIdentity=='1'){
                $scope.param.param.confirmStatus='02'
            }
        })
        function isShow(isSuccess){
            if(!isSuccess){
                $scope.cancel()
            }
        }
        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        // 下载到本地
        $scope.downloadLocal = function downloadLocal() {
            if ($scope.selectedInvoices.length === 0) {
                logger.logError('请选择红字确认单')
                return
            }
            $scope.selectedInvoices.forEach((item,index)=>{
                item.ukeyId =  $scope.param.param.ukeyId
                item.invoiceType =  $scope.param.param.invoiceType
            })
            utils.loading('下载中...')
            httpRequest.post_downloadRedConfirmById($scope.selectedInvoices).then((res) => {
                utils.loaded()
                if (res.data.success) {
                    logger.logSuccess('下载成功')
                    $uibModalInstance.close(res.data.success)
                } else {
                    logger.logError(res.data.errorMsg)
                }
            })
        }
        $scope.ukeyChange = function ukeyChange() {
            const newUkeyListArr = $scope.ukeyList.filter((item) => item.ukeyId === $scope.param.param.ukeyId)
            $scope.manageType = newUkeyListArr[0].manageType
        }
    }
}

redInkConfirmFormDownloadCtrl.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', 'sweetalert', '$filter', '$uibModalInstance', '$stateParams']
export default redInkConfirmFormDownloadCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/downloadCtrl.js